<div class="message-container">
  @if (notifications.length > 1) {
    <div class="previousMessage">
      <a
        class="previousMessage-button"
        (click)="previousMessage()"
      >
        <mat-icon>
          navigate_before
        </mat-icon>
      </a>
    </div>
  }

  <ul>
    @for (message of notifications; track $index) {
      <li>
        @if (currentIndex === $index) {
          <div class="message-container__message">
            @if (message.name !== 'upComing') {
              <div>
                <div class="message-container__message__title">
                  <h3>
                    {{message.title}}
                  </h3>
                </div>

                @if (message.message) {
                  <div class="message-container__message__ingress">
                    <div class="message-container__message__ingress__vertical-line bg-blue"></div>

                    <h5>
                      {{message.message}}
                    </h5>
                  </div>
                }
              </div>
            }
            @else if (message.name === 'upComing') {
              <div>
                <div class="message-container__message__title">
                  <h3>
                    {{message.message.title}}
                  </h3>
                </div>

                @if (message.message.description) {
                  <div class="message-container__message__ingress">
                    <div class="message-container__message__ingress__vertical-line bg-blue"></div>

                    <h5>
                      {{message.message.description}}
                    </h5>
                  </div>
                }

                <div class="what-is-new__table">
                  <div class="what-is-new__table__row what-is-new__table__row-header">
                    <div class="what-is-new__table__row-item">
                      <span>
                        {{ 'TRANS__EDITION__WHATS_NEW' | translate:{version: message.version} }}
                      </span>
                    </div>

                    <div class="what-is-new__table__row-item">
                      {{ 'TRANS__EDITION__SMALL' | translate }}
                    </div>

                    <div class="what-is-new__table__row-item">
                      {{ 'TRANS__EDITION__LARGE' | translate }}
                    </div>

                    <div class="what-is-new__table__row-item">
                      {{ 'TRANS__EDITION__MEDIUM' | translate }}
                    </div>
                  </div>

                  @for (change of message.what_is_new; track $index) {
                    <div class="what-is-new__table__row what-is-new__table__row-content">
                      <div class="what-is-new__table__row-item">
                        <span>
                          {{change.description}}
                        </span>
                      </div>

                      @for (edition of change.edition; track $index) {
                        <div class="what-is-new__table__row-item {{edition}}">
                          @if (edition === 'small' || edition === 'large' || edition === 'medium') {
                            <mat-icon>
                              check
                            </mat-icon>
                          }
                        </div>
                      }
                    </div>
                  }
                </div>
              </div>
            }
          </div>
        }
      </li>
    }
  </ul>

  @if (notifications.length > 1) {
    <ul class="carousel-indicators">
      @for (message of notifications; track $index) {
        <li
          (click)="goToMessage($index)"
          (keydown)="null"
          [ngClass]="{'bg-blue': currentIndex === $index}"
        ></li>
      }
    </ul>

    <div class="carousel-indicators-text">
        <span>
          {{ 'TRANS__MESSAGE__INDICATOR_TEXT' | translate:{page: currentIndex + 1, total: notifications.length} }}
        </span>
    </div>

    <div class="nextMessage">
      <a
        class="nextMessage-button"
        (click)="nextMessage()"
      >
        <mat-icon>
          arrow_forward_ios
        </mat-icon>
      </a>
    </div>
  }

  <div class="message-container__bottom">
    <i class="icon-primus"></i>

    <div class="vertical-line vLine1"></div>

    <span>
      {{ 'TRANS__ADMIN__HELP__CONTACT' | translate }}
    </span>

    <span>
      {{ 'TRANS__ADMIN__HELP__NUMBER' | translate }}
    </span>

    <div class="vertical-line vLine2"></div>

    <span>
      {{ 'TRANS__ADMIN__HELP__MAIL' | translate }}
    </span>

    <a class="text-blue-hover" href="mailto:support@kulturit.no">
      support&#64;kulturit.no
    </a>
  </div>
</div>
